/**
 * Development feature flags.
 * Use prefix "dev" and set them to 0 by default
 * This way:
 * - User will not be able to see them in the app/web
 * - We don't need to declare them on firebase
 * - We can test them locally enabling the feature flag from A/B test screen
 */
const localRemotes = {
  // dev_is_example_feature_enabled: 0,
};

export default localRemotes;
